import type { AxiosInstance } from "axios";
import axios from "axios";
import { multiUserApi } from "../../../../shared/utils/multiUserFunctions";
import { getAccessToken } from "../../utils";
import type { ICreateApiInstanceOptions } from "../types";

export const recreateApiInstance = ({
  setUserInfo,
  replacementToken = false,
  baseUrl,
  skipLogoutOn401,
}: Omit<ICreateApiInstanceOptions, "instance"> & {
  baseUrl: string;
}): AxiosInstance => {
  const instance = axios.create({ baseURL: baseUrl });

  instance.interceptors.request.use((config) => {
    const token = `Bearer ${getAccessToken()}`;
    if (config.headers) {
      config.headers.Authorization = token;
      config.headers["X-Keycloak-Token"] =
        multiUserApi.getUserKey("access_token");
    }
    if (replacementToken) {
      config.headers["OpenAI-Beta"] = "assistants=v2";
    }
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        if (skipLogoutOn401) {
          return Promise.reject(error);
        }
        if (multiUserApi.parseToArray().length > 1) {
          multiUserApi.removeUser();
          window.location.reload();
        } else {
          multiUserApi.removeUser();
          setUserInfo();
        }
      }
      return Promise.reject(error);
    },
  );

  return instance;
};
